import { dispatchTrackingEventGA4 } from 'common/tracking/dispatchTrackingEventGA4';
import { Element, NavigationParent } from 'common/types/tracking';

interface TrackNavigationItemClickOptions {
  label: string;
  length: number;
  position: number;
  parentComponent?: NavigationParent;
  element?: Element;
  shopName?: string;
}

const enum TopNavigationEvent {
  GlobalHeaderClick = 'global-header-top-nav_click',
  ShopInShopNavClick = 'shop-in-shop-top-nav_click',
}

export const trackNavigationItemClick = ({
  parentComponent = NavigationParent.GlobalHeader,
  element = Element.Link,
  label,
  length,
  position,
  shopName,
}: TrackNavigationItemClickOptions) => {
  dispatchTrackingEventGA4({
    event:
      parentComponent === NavigationParent.ShopInShopNav
        ? TopNavigationEvent.ShopInShopNavClick
        : TopNavigationEvent.GlobalHeaderClick,
    element,
    clicked_text: label,
    list_length: length,
    list_position: position,
    nav_level: 'L1',
    ...(shopName && { shop_name: shopName }),
  });
};

export const trackCategoriesButtonClick = (label: string, shopName?: string) => {
  dispatchTrackingEventGA4({
    event: TopNavigationEvent.ShopInShopNavClick,
    element: Element.Button,
    clicked_text: label,
    shop_name: shopName,
  });
};
